import Illustration from './Illustration';

export default Illustration;
